(function () {
  'use strict';

  var selectors = {
    productImages: 'product-images',
    dotItem: '[data-dot-item]',
  };

  var attributes = {
    activeMedia: 'data-active-media',
    mediaId: 'data-media-id',
  };

  var classes = {
    active: 'is-selected',
  };

  class ProductDots extends HTMLElement {
    constructor() {
      super();

      this.productImagesContainer = this.closest(selectors.productImages);
      this.dotItems = this.querySelectorAll(selectors.dotItem);
    }

    connectedCallback() {
      this.handleClicks();
      this.observeActiveMedia();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    handleClicks() {
      this.dotItems.forEach((dot) => {
        dot.addEventListener('click', () => {
          if (dot.classList.contains(classes.active)) return;

          var id = dot.getAttribute(attributes.mediaId);

          this.dispatchEvent(
            new CustomEvent('theme:media:select', {
              bubbles: true,
              detail: { id: id },
            })
          );
        });
      });
    }

    observeActiveMedia() {
      if (!this.productImagesContainer) return;

      this.setActiveDot();

      this.observer = new MutationObserver((mutations) => {
        for (var i = 0; i < mutations.length; i++) {
          var mutation = mutations[i];
          if (mutation.type === 'attributes' && mutation.attributeName === attributes.activeMedia) {
            this.setActiveDot();
            break;
          }
        }
      });

      this.observer.observe(this.productImagesContainer, {
        attributes: true,
        childList: false,
        subtree: false,
      });
    }

    setActiveDot() {
      var activeId = this.productImagesContainer.getAttribute(attributes.activeMedia);
      var activeDot = this.querySelector('[' + attributes.mediaId + '="' + activeId + '"]');
      var currentActive = this.querySelector(selectors.dotItem + '.' + classes.active);

      if (currentActive) currentActive.classList.remove(classes.active);
      if (activeDot) activeDot.classList.add(classes.active);
    }
  }

  if (!customElements.get('product-dots')) {
    customElements.define('product-dots', ProductDots);
  }
})();
